<template>
  <!-- <div class="footer tabbar row" style="z-index: 5">
    <a :class="['cc', {'active': homeActive}]" @click="toHome">
      <i class="iconfont icon-1"></i>
      <span>首页</span>
    </a>
    <a :class="['cc', {'active': categoryActive}]" @click="toCategory">
      <i class="iconfont icon-2"></i>
      <span>分类</span>
    </a>
    <a :class="['cc', {'active': shelfActive}]" @click="toShelf">
      <i class="iconfont icon-3"></i>
      <span>书架</span>
    </a>
    <a :class="['cc', {'active': userActive}]" @click="toMine">
      <i class="iconfont icon-4"></i>
      <span>我的</span>
    </a>
  </div>-->
  <footer class="aui-footer aui-footer-fixed">
    <a @click="toHome" class="aui-tabBar-item" :class="{'aui-tabBar-item-active': homeActive}" >
      <span class="aui-tabBar-item-icon">
        <i class="icon icon-city" :class="{'icon-city-active': homeActive}"></i>
      </span>
      <span class="aui-tabBar-item-text">书城</span>
    </a>
    <a class="aui-tabBar-item" :class="[{'aui-tabBar-item-active': categoryActive}]" @click="toCategory">
      <span class="aui-tabBar-item-icon">
        <i class="icon icon-cat" :class="{'icon-cat-active': categoryActive}"></i>
      </span>
      <span class="aui-tabBar-item-text">分类</span>
    </a>
    <a  class="aui-tabBar-item"  :class="[{'aui-tabBar-item-active': newActive}]" @click="toNew">
      <span class="aui-tabBar-item-icon">
        <i class="icon icon-orig" :class="[{'icon-orig-active': newActive}]"></i>
      </span>
      <span class="aui-tabBar-item-text">更新</span>
    </a>
    <a class="aui-tabBar-item" :class="[{'aui-tabBar-item-active': shelfActive}]" @click="toShelf">
      <span class="aui-tabBar-item-icon">
        <i class="icon icon-book" :class="{'icon-book-active': shelfActive}"></i>
      </span>
      <span class="aui-tabBar-item-text">书架</span>
    </a>
    <a  class="aui-tabBar-item" :class="[{'aui-tabBar-item-active': userActive}]" @click="toMine">
      <span class="aui-tabBar-item-icon">
        <i class="icon icon-my" :class="{'icon-my-active': userActive}"></i>
      </span>
      <span class="aui-tabBar-item-text">我的</span>
    </a>
  </footer>
</template>

<script>
export default {
  name: 'layer1',
  computed: {
    homeActive () {
      return this.$route.name === 'home'
    },
    categoryActive () {
      return this.$route.path === '/category'
    },
    newActive () {
      return this.$route.path === '/new'
    },
    shelfActive () {
      return this.$route.path === '/shelf'
    },
    userActive () {
      return this.$route.path === '/user'
    }
  },
  methods: {
    toHome () {
      if (this.$route.name === 'home') return
      this.$router.isBack = false
      this.$router.push('/home')
      // this.$emit('page-change', 'home')
    },
    toCategory () {
      if (this.$route.name === 'category') return
      this.$router.isBack = false
      this.$router.push('/category')
      // this.$emit('page-change', 'category')
    },
    toNew () {
      if (this.$route.name === 'new') return
      this.$router.isBack = false
      this.$router.push('/new')
      // this.$emit('page-change', 'shelf')
    },
    toShelf () {
      if (this.$route.name === 'shelf') return
      this.$router.isBack = false
      this.$router.push('/shelf')
      // this.$emit('page-change', 'shelf')
    },
    toMine () {
      if (this.$route.name === 'user') return
      this.$router.isBack = false
      this.$router.push('/user')
      // this.$emit('page-change', 'user')
    }
  }
}
</script>

<style scoped>
/*
  a.active {
    background-color: #f0f0f0;
  }
  a.active span {
    color: #000000;
  }
   */
</style>
